import { URLKeys } from 'src/types/URLKeys';

export const endPoints = {
  SivChecklist: {
    select: {
      url: 'sivChecklist/{site_id}/{study_id}/select?country={country}&application={application}&monitoring_visit_id={monitoring_visit_id}',
      keepUnusedDataFor: 30
    },
    signSivChecklist: `/sivChecklist/{site_id}/{study_id}/sign`,
    getAll: `sivChecklist/getAll`,
    pulishEtmf: `sivChecklist/{study_id}/{site_id}/publish/eTMF`,
    notifyUser: `sivChecklist/{site_id}/{study_id}/notifyUser`
  },
  SivReport: {
    select: {
      url: 'sivReport/{site_id}/{study_id}/select?country={country}&application={application}&monitoring_visit_id={monitoring_visit_id}',
      keepUnusedDataFor: 30
    },
    getAll: {
      url: 'sivReport/{site_id}/{study_id}/getAll?country={country}&application={application}&monitoring_visit_id={monitoring_visit_id}',
      keepUnusedDataFor: 30
    },
    signSivReport: `/sivReport/{site_id}/{study_id}/sign`,
    getAllSivReports: `sivReport/getAll`,
    pulishEtmf: `sivReport/{study_id}/{site_id}/publish/eTMF`,
    notifyUsers: `/sivReport/{site_id}/{study_id}/notifyUser`
  },
  Audit: { getAll: `/audit/getAll`, applyFilterGetAll: `audit/applyFilter/{audit_module_section}/{id}/getAll` },
  AccessRequest: { get: `/accessRequest/{site_id}/{study_id}`, getPersonnel: `/accessRequest/{personnel_id}` },
  Budget: {
    create: `/startup/budget/{site_id}/{study_id}/create`,
    select: `/startup/budget/{site_id}/{study_id}/select`,
    update: `/startup/budget/{site_id}/{study_id}/update`
  },
  Checklist: {
    create: `/site/checklist/{site_id}/{study_id}/create`,
    select: `/site/checklist/{site_id}/{study_id}/select`,
    update: `/site/checklist/{site_id}/{study_id}/update`,
    pulishEtmf: `/site/checklist/{study_id}/{site_id}/publish/eTMF`,
    createPIL: `/sqChecklist/{site_id}/{study_id}/create`,
    selectPIL: `/sqChecklist/{site_id}/{study_id}/select`,
    updatePIL: `/sqChecklist/{site_id}/{study_id}/update`,
    getAll: `site/checklist/getAll`,
    getAllPIL: `/sqChecklist/getAll`
  },
  Feasibility: {
    getAll: `/startup/feasibilityChecks/getAll`,
    create: `/startup/feasibilityChecks/{site_id}/{study_id}/create`,
    select: `/startup/feasibilityChecks/{site_id}/{study_id}/select`,
    update: `/startup/feasibilityChecks/{site_id}/{study_id}/update`,
    updateCheckbox: `/startup/feasibilityChecks/{site_id}/{study_id}/update_checkBox`
  },
  FileMaster: {
    add: `/fileMaster/uploadFiles`,
    download: `/fileMaster/downloadFile/{file_id}`,
    delete: `/fileMaster/deleteFile/{file_id}`
  },
  IPSupplyOrder: {
    create: `/startup/ipSupply/{site_id}/{study_id}/create`,
    select: `/startup/ipSupply/{site_id}/{study_id}/select`,
    update: `/startup/ipSupply/{site_id}/{study_id}/update`,
    getDrugName: `/startup/ipSupply/{site_id}/{study_id}/selectDrugName`,
    sendEmail: `email/{study_id}/{site_id}/send`,
    approveUpdate: `/startup/ipSupply/{site_id}/{study_id}/{ip_supply_id}/update`,
    downloadCSV: `/email/{study_id}/{site_id}/{ip_supply_id}/downloadCsv`
  },
  IPSupplyDetails: {
    select: `/startup/ipSupplyDetails/{site_id}/{study_id}/select`,
    create: `/startup/ipSupplyDetails/{site_id}/{study_id}/create`,
    getAll: `/workarea/ipTreatments/{study_id}/getAll`
  },
  MileStone: {
    create: `/site/milestone/{site_id}/{study_id}/create`,
    getAll: `/site/milestone/{site_id}/{study_id}/getAll`,
    update: `/site/milestone/{site_id}/{study_id}/update`,
    milestoneSelect: `/site/milestone/{milestone_id}/select`,
    milestoneUpdate: `/site/milestone/{milestone_id}/update`,
    milestoneProgressSelect: `/site/milestone/progress/{site_id}/{study_id}/select`,
    milestoneapplyFilterSelect: `/site/milestone/applyFilter/{site_id}/{study_id}/select`,
    ganttChartGetAll: `/site/milestone/ganttChart/{site_id}/{study_id}/getAll`,
    milstoneAuditFilterGetAll: `/audit/applyFilter/{audit_module_section}/{row_id}/getAll`,
    updateStartPlannedDates: `/site/milestone/{milestone_id}/updateStartPlannedDate`,
    updateEndPlannedDates: `/site/milestone/{milestone_id}/updateEndPlannedDate`,
    Activate: `/site/milestone/{site_id}/{study_id}/activateMileStone`,
    Reactivate: `/site/milestone/{milestone_id}/reactivate`,
    updateActualDates: `/site/milestone/{site_id}/{study_id}/{milestone_id}/updateActualDates`
  },
  Personnel: {
    select: `/personnel/{site_id}/{study_id}/select`,
    personnelSelect: `/personnel/{personnel_id}/select`,
    update: `/personnel/update`,
    create: `/personnel/{site_id}/{study_id}/create`,
    delete: `/personnel/{personnel_id}/delete`
  },
  Report: {
    create: `/site/report/{site_id}/{study_id}/create`,
    select: `/site/report/{site_id}/{study_id}/select`,
    update: `/site/report/{site_id}/{study_id}/update`,
    getAll: `/site/report/getAll`,
    pulishEtmf: `/site/report/{study_id}/{site_id}/publish/eTMF`
  },

  Site: {
    getAll: `/site/getAll`,
    update: `/site/{site_id}/{study_id}/update?country={country}&application={application}`
  },

  SiteStudy: {
    select: `/siteStudy/select`
  },

  SiteStudyPersonnel: {
    siteStudyPersonnelSelect: `/siteStudyPersonnel/{site_id}/{study_id}/select`,
    select: `/siteStudyPersonnel/{site_id}/{study_id}/select`,
    personnelSelect: `/siteStudyPersonnel/personnel/{site_id}/{study_id}/select`,
    update: `/personnel/personnel_update`,
    updateFics: `/personnel/update`,
    create: `/personnel/{study_id}/create`
  },
  siteInfo: {
    update: `/workarea/site/siteinfo/{site_id}/update`,
    updateStudyIdentified: `/workarea/{site_id}/{study_id}/update`
  },
  Startup: {
    study: `/startup/create/study`
  },
  study: {
    select: `/study/{site_id}/select`,
    getAll: `/study/getAll`,
    countrySelect: `/study/country/{study_id}/select`,
    studyInfo: `/study/studyInfo`
  },
  EssentialDocuments: {
    getAll: `/essentialDocuments/{site_id}/{study_id}/getAll`,
    update: `/essentialDocuments/{site_id}/{study_id}/update`
  },
  IpRelease: {
    create: `/ipRelease/{site_id}/{study_id}/create`,
    getAll: `/ipRelease/{site_id}/{study_id}/getAll`,
    update: `/ipRelease/{site_id}/{study_id}/update`
  },
  Queries: {
    create: `/queries/{site_id}/{study_id}/create?country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`,
    select: `/queries/{site_id}/{study_id}/select?country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`,
    update: `/queries/{site_id}/{study_id}/update?country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`,
    delete: `/queries/{site_id}/{study_id}/delete?country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`,
    forward: `/queries/{site_id}/{study_id}/forward?country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`
  },
  QueryResponse: {
    create: `/queryResponse/{query_id}/create?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}&application_module_section={application_module_section}`,
    bulkCreate: `/queryResponse/create?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}`,
    select: `/queryResponse/{query_id}/select?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}`
  },
  CodeList: {
    select: `/codeList/{code_list_code}/select`,
    newSelect: `/codeListLibrary/codeListValue/{code_list_code}/getAll`,
    getAll: `/codeListLibrary/codeListValue/{code_list_code}/getAll?application=CTMS&application_section=SYSADMIN`,
    getAllCodeList: `/codeListLibrary/codeListValue/getAll`
  },
  sysAdmin: {
    groups: `/groups`,
    selectPharmacy: `/workarea/site/{study_id}/{site_id}/selectPharmacy`
  },
  Utils: {
    selectStudies: '/utils/study/getAll',
    selectCountries: '/utils/country/getAll',
    selectSites: '/utils/site/getAll',
    assignees: `/users/{client_name}/users`,
    allAssignees: `/users`,
    serverDateTime: `/utils/server_datetime`
  },
  UserGroupManagement: {
    selectClientRoles: '/sysAdmin/groups/{group_name}/clientRoles/{client_name}'
  },
  UserClicks: {
    select: '/userClick/select',
    create: '/userClick/create'
  },
  ticket: {
    create: `/workarea/ticket/create`,
    list: `/workarea/ticket/getAll`,
    getPersonelTicket: `/workarea/ticket/getPersonnelTicket`
  },
  etmfApis: {
    getAll: `masterDocument/getAll`,
    createMasterDoc: `masterDocument/create`,
    getDcocListByStudyidArtifactname: `masterDocument/{study_id}/select`,
    getDocLevelByArtifactName: `tmfLevel/docInfo/{tmf_doc_level}/select`,
    getTmfLevel: `tmfLevel/{tmf_level}/select`,
    updateInlineMasterDoc: `masterDocument/inlineUpdate`,
    emailActivity: `/email/send`,
    getTmfDocDetailsByStudyDocId: `masterDocument/{study_id}/select`,
    getDrugSupplyArtifacts: `/tmfLevel/drugSupplyArtifacts/getAll`,
    deleteMasterDoc: `masterDocument/{file_master_id}/delete`,
    deleteAllDocuments: `masterDocument/deleteAll`
  },
  AccessStudyLogs: {
    getStudyLogs: `accessStudyLog/{site_id}/{study_id}`
  },
  StudyLogs: {
    getAll: `studyLog/getAll`
  },
  DOA: {
    getAll: `/DOALink/{site_id}/{study_id}/getAll`,
    updateSignature: `/DOALink/{id}/update_signature`,
    getPageLevelSignature: `DOALink/{site_id}/{study_id}/get_page_signature`,
    updatePageLevelSignature: `DOALink/{site_id}/{study_id}/update_page_signature`,
    doaLinkUpdate: `DOALink/{id}/update`,
    doaLinkcreate: `DOALink/{site_id}/{study_id}/create`,
    doaLinkDelete: `DOALink/{id}/delete`,
    publishToIsf: `DOALink/{study_id}/{site_id}/publish`,
    updatePublishToIsf: `DOALink/{study_id}/{site_id}/update_publish`
  },
  TrainingLogs: {
    getAll: `/trainingLog/{site_id}/{study_id}/getAll`,
    updateSignature: `/trainingLog/{id}/update_signature`,
    getPageLevelSignature: `trainingLog/{site_id}/{study_id}/get_page_signature`,
    updatePageLevelSignature: `trainingLog/{site_id}/{study_id}/update_page_signature`,
    UpdateTrainingLog: `trainingLog/{site_id}/{study_id}/{id}/update`,
    trainingLogcreate: `trainingLog/{site_id}/{study_id}/create`,
    tariningDocDelete: `trainingLog/{id}/{documentName}/delete_file`,
    trainingLogDelete: `trainingLog/{id}/delete`
  },
  From1572: {
    getAll: `/1572/{site_id}/{study_id}/getAll`,
    updateSign: `1572/{id}/update_signature`,
    publish: `1572/{id}/publish`,
    update: `1572/{site_id}/{study_id}/{id}/update`,
    create: `1572/{site_id}/{study_id}/create`
  },
  DrugAccountabilityRecord: {
    getIpList: `/drugAccountRecord/kit/{site_id}/{study_id}/ips/getall`,
    create: `/drugAccountRecord/kit/{site_id}/{study_id}/create`,
    getStudyInfo: `/study/studyInfo/{study_id}/select`,
    getSiteInfo: `/site/siteInfo/{site_id}/select`,
    getDrugAccontRecord: `/drugAccountRecord/kit/{site_id}/{study_id}/{ip_name}/getAll`,
    updateDARDoc: `drugAccountRecord/event/{event_id}/documents/update`,
    DrugKitRecrodUpdate: `/drugAccountRecord/kit/{id}/update`,
    DrugKitDocUpdate: `/drugAccountRecord/kit/{kit_id}/documents/update`,
    DrugKitCreateNotes: `/drugAccountRecord/kit/{kit_id}/notes/createNotes`,
    DrugKitGetAllNote: `/drugAccountRecord/kit/{kit_id}/notes/getAllNotes`
  },
  Overview: {
    getAll: `/drugAccountRecord/event/{site_id}/{study_id}/{kit_id}/getAll`,
    getAllDisepended: `/drugAccountRecord/event/{site_id}/{study_id}/{kit_id}/getAllDispensed`,
    DARNotesCreate: `/drugAccountRecord/event/{event_id}/notes/create`,
    DARNotesGetAll: `/drugAccountRecord/event/{event_id}/notes/getAll`,
    DrugEventRecordsGetAll: `/drugAccountRecord/event/{site_id}/{study_id}/{kit_id}/getAll`,
    DrugEventRecordsCreate: `/drugAccountRecord/event/{site_id}/{study_id}/{kit_id}/create`,
    DrugEventRecordsUpdate: `/drugAccountRecord/event/{id}/update`
  },
  ISFApis: {
    selectIsfDocInfoByLevelAndName: `isfLevel/docInfo/{level_type}/select`,
    getAllIsfDocsByArtifcatNumberSitelevel: `masterDocument/getAll`,
    uploadIsfFile: `fileMaster/uploadFile`,
    createMasterDoc: `masterDocument/create`,
    deleteIsfDocByFileMasterId: `masterDocument/{file_master_id}/delete`,
    deleteAllIsfDocsByFileMasterIds: `masterDocument/deleteAll`,
    getIsfDocDetailsByStudyDocId: `masterDocument/{study_id}/select`,
    updateInlineMasterDoc: `masterDocument/inlineUpdate`
  },

  //From Conduct
  ImvChecklist: {
    create: `/conductIMVChecklist/{site_id}/{study_id}/create`,
    select: `/conductIMVChecklist/{site_id}/{study_id}/select`,
    update: `/conductIMVChecklist/{site_id}/{study_id}/update`,
    getAll: `/conductIMVChecklist/getAll`,
    upload: `/conductIMVChecklist/getFiles`,
    publish: `/conductIMVChecklist/{study_id}/{site_id}/publish`
  },
  subjectTrackingData: {
    getAll: `/conduct/subjectTracking/getAll`,
    getPrescreenId: `/conduct/subjectTracking/{prescreen_id}/select`
  },
  dataMonitoring: {
    select: `/conductMonitoring/{study_id}/getAll`,
    update: `/conductMonitoring/{study_id}/update`
  },
  MilestoneQueries: {
    create: `/queries/{site_id}/{study_id}/create?country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`,
    select: `/queries/{site_id}/{study_id}/select?country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`,
    update: `/queries/{site_id}/{study_id}/update?country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`,
    delete: `/queries/{site_id}/{study_id}/delete?country={country}&application={application}&application_section=CONDUCT&application_module_section=MILESTONE TRACKING`
  },
  MilestoneQueryResponse: {
    create: `/queryResponse/{query_id}/create?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`,
    bulkCreate: `/queryResponse/create?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`,
    select: `/queryResponse/{query_id}/select?site_id={site_id}&study_id={study_id}&country={country}&application={application}&application_section={application_section}&application_module_section=MILESTONE TRACKING`
  },
  DataReview: {
    getAll: `conduct/dataReview/{study_id}/getAll`,
    crfSummarySelect: `conduct/dataReviewcrfSummary/{study_id}/{subject_id}/select?visit={visit}`,
    getAllVisits: `conduct/dataReviewvisit/{study_id}/getAll`,
    getDataReviewcrfs: `conduct/dataReviewcrfs/{study_id}/select`
  },
  calendarVisits: {
    getAll: `conduct/dataReview/subjectVisits/{study_id}/getAll`
  },
  conductDataReview: {
    select: `/conduct/dataReviewcrfSummary/{study_id}/{subject_id}/select?visit={visit}`,
    summaryselectAll: `/conduct/dataReviewcrfSummary/{study_id}/{subject_id}/select`,
    getAll: `/conduct/dataReview/{study_id}/getAll`
  },
  conductStudyLog: {
    getAll: `/conductStudyLog/getAll`,
    selectActionLogData: `/conductActionLog/{site_id}/{study_id}/getAll`,
    selectProtocolDeviationData: `/conductProtocolDeviationsLog/{site_id}/{study_id}/getAll`
  },
  conductIssueLog: {
    getAll: `/conductIssueLog/getAll`,
    create: `/conductIssueLog/{study_id}/create`,
    put: `/conductIssueLog/{issue_id}/update`,
    updateIssueAction: `/conductIssueLog/{issue_id}/updateIssueAction`,
    delete: `/conductIssueLog/{issue_id}/delete`,
    updateIssueDecision: `/conductIssueLog/{issue_id}/updateIssueDecision`,
    deleteAll: `/conductIssueLog/{issue_id}/deleteAll`,
    updateAll: `/conductIssueLog/{issue_id}/updateAll`,
    copyToSponsor: `/conductIssueLog/{study_id}/{site_id}/copy`
  },
  conductDecisionLog: {
    getAll: `conductDecisionLog/{site_id}/{study_id}/getAll`
  },
  conductProtocolQALog: {
    getAll: `/conductProtocolQALog/getAll`,
    create: `/conductProtocolQALog/{study_id}/create`,
    copyQuestion: `/conductProtocolQALog/{study_id}/{site_id}/copy`,
    updateOtherResponse: `conductProtocolQALog/{id}/updateOtherResponse`,
    updateResponse: `conductProtocolQALog/{id}/updateResponse`,
    updateStatus: `conductProtocolQALog/{id}/updateStatus`,
    delete: `conductProtocolQALog/{id}/delete`,
    deleteOther: `conductProtocolQALog/{id}/deleteOther`,
    update: `conductProtocolQALog/{id}/update`,
    updateOther: `conductProtocolQALog/{id}/updateOther`
  },
  conductProtocolDeviationsLog: {
    getAll: `/conductProtocolDeviationsLog/getAll`,
    create: `/conductProtocolDeviationsLog/{study_id}/create`,
    update: `/conductProtocolDeviationsLog/{id}/update`,
    delete: `/conductProtocolDeviationsLog/{id}/delete`,
    updateDeviationAction: `/conductProtocolDeviationsLog/{id}/updateDeviationAction`,
    updateDeviationDecision: `/conductProtocolDeviationsLog/{id}/updateDeviationDecision`,
    deleteAll: `/conductProtocolDeviationsLog/{id}/deleteAll`,
    updateAll: `/conductProtocolDeviationsLog/{id}/updateAll`,
    copy: `/conductProtocolDeviationsLog/{study_id}/{site_id}/copy`
  },
  codeListValueCode: {
    read: `/codeListLibrary/codeListValue/{code_list_code}/getAll`
  },
  monitoringEvent: {
    create: `/monitoringEvent/{site_id}/{study_id}/{country}/create`,
    getAll: `/monitoringEvent/getAll`,
    select: `/monitoringEvent/{id}/select`,
    update: `/monitoringEvent/{site_id}/{study_id}/{country}/{id}/update`,
    unscheduledvisitCrf: `/loadPatientDetails/{study_id}/unscheduledVisitCRFs/getAll`,
    unScheduledVisitCreate: `/inTrialPatients/{study_id}/createUnscheduledAppointments`
  },
  ImvReport: {
    getAll: `/ConductIMVReport/getAll`,
    create: `/ConductIMVReport/{site_id}/{study_id}/create`,
    select: `/ConductIMVReport/{site_id}/{study_id}/select`,
    update: `/ConductIMVReport/{site_id}/{study_id}/update`,
    sendForReview: `/ConductIMVReport/{site_id}/{study_id}/notifyUser`,
    sign: `/ConductIMVReport/{site_id}/{study_id}/sign`,
    publish: `/ConductIMVReport/{study_id}/{site_id}/publish`
  },
  subjectCRFs: {
    getVisitCRFOIDs: `/trialNotebookCRF/{study_id}/getVisitCRFOIDs`,
    getCRFDetails: `/trialNotebookCRF/{study_id}/{parent_id}/{OID}/getPatientCRFDetails`,
    //getAllPatientDetails: `/loadPatientDetails/getAll`,
    getAllPatientDetails: `/preScreenEligibleCriteria/patients`,
    getVisitLinkedCRFs: `trialNotebookCRF/{study_id}/{visit_id}/getVisitLinkedCRFs`,
    getStudyAllCRFVisits: `trialNotebookCRF/{study_id}/getAllVisits`,
    selectCRFDataByID: `/trialNotebookCRF/{study_id}/{site_id}/selectCRFDataByID`
  },
  subjectTracking: {
    createVerification: `/conduct/subjectTracking/{study_id}/{country}/{site_id}/createVerification`,
    getAllVerification: `/conduct/subjectTracking/{parent_id}/{record_id}/{form_oid}/{visit_uuid}/{crf_data_id}/getAllVerification`,
    sourceDataReviewStatus: `/conduct/subjectTracking/{parent_id}/{record_id}/{form_oid}/{visit_uuid}/{crf_data_id}/reviewStatus`
  },
  VisitConfirmation: {
    getAllVisit: `/ConductVisitConfirmation/getAll`,
    getPublishVisit: `/ConductVisitConfirmation/publishedLetters/getAll`,
    select: `/ConductVisitConfirmation/{site_id}/{study_id}/select`,
    create: `/ConductVisitConfirmation/{site_id}/{study_id}/create`,
    update: `/ConductVisitConfirmation/{site_id}/{study_id}/update`,
    publish: `/ConductVisitConfirmation/{study_id}/{site_id}/eTMF/publish`
  },
  sqConfirmationLatter: {
    getAll: `/siteConfirmationLetter/getAll`,
    getPublishAll: `siteConfirmationLetter/publishedLetters/getAll`,
    select: `/siteConfirmationLetter/{site_id}/{study_id}/select`,
    update: `/siteConfirmationLetter/{site_id}/{study_id}/update`,
    sign: `/siteConfirmationLetter/{site_id}/{study_id}/sign`,
    publish: `/siteConfirmationLetter/{study_id}/{site_id}/publishToEtmf`,
    createNewVersion: `/siteConfirmationLetter/{site_id}/{study_id}/{sq_visit_id}/newSQConfirmationVersion`
  },
  ImvFollowUp: {
    getAll: `/ConductVisitFollowUp/getAll`,
    getPublish: `/ConductVisitFollowUp/publishedLetters/getAll`,
    select: `/ConductVisitFollowUp/{site_id}/{study_id}/select`,
    create: `/ConductVisitFollowUp/{site_id}/{study_id}/create`,
    update: `/ConductVisitFollowUp/{site_id}/{study_id}/update`,
    publish: `/ConductVisitFollowUp/{site_id}/{study_id}/eTMF/publish`
  },
  sqFollowupLatter: {
    getAll: `/sqFollowUpLetter/getAll`,
    getPublish: `/sqFollowUpLetter/publishedLetters/getAll`,
    select: `/sqFollowUpLetter/{site_id}/{study_id}/select`,
    update: `/sqFollowUpLetter/{site_id}/{study_id}/update`,
    sign: `/sqFollowUpLetter/{site_id}/{study_id}/sign`,
    publish: `/sqFollowUpLetter/{study_id}/{site_id}/publishToEtmf`,
    createNewVersion: `/sqFollowUpLetter/{site_id}/{study_id}/{sq_visit_id}/newSQFollowUpVersion`
  },
  EligiblePatientAPI: {
    // getAll: `/eligiblePatients/getAll`,
    getAll: `/preScreenEligibleCriteria/getAll`,
    updateStatus: `/eligiblePatients/updateStatus`
  },
  InTrailPatientAPI: {
    getAll: `/inTrialPatients/getAll`,
    removeInTrail: `/eligiblePatients/removeFromTrial/updateStatus`
  },
  PatientDetailsAPI: {
    // getAll: `/loadPatientDetails/getAll`,
    getAll: `/preScreenEligibleCriteria/patients`,
    // patientIdentifierSelect: `/loadPatientDetails/patientIdentifier/{core_fics_patient_identifier}/select`,
    patientIdentifierSelect: `/preScreenEligibleCriteria/{patient_id}/select`,
    prescreeningIdSelect: `/loadPatientDetails/prescreening/{prescreen_id}/select`,
    subjectIDSelect: `/eligiblePatients/subject_id/{subject_id}/select`
  },
  failPreScreenAPI: {
    preScreenUpdateStatus: `/eligiblePatients/prescreenFail/updateStatus`,
    getAllPrescreenFail: `/eligiblePatients/getAllPreescreenFailData`
  },
  PatientTrialNotebookAPI: {
    getSubjectToolKitForms: `/subjectToolkit/getForms`,
    assignSubject: `toolkitForm/{study_id}/{parent_id}/assignToSubject`,
    getAssignedForms: `toolkitForm/{study_id}/{parent_id}/getAssignedForms`
  },
  toolkitFormsAPI: {
    getConfiguredForms: `/toolkitForm/{study_id}/getConfiguredForms`,
    //getFormLibrary: `/formLibrary/{OID}/{published_version}/getForm`,
    getFormLibrary: `/formLibrary/{OID}/{published_version}/getStudyForm`,
    createFormData: `/toolkitForm/createData`,
    selectFormData: `/toolkitForm/selectData`,
    updateFormData: `/toolkitForm/updateData`,
    signToolkitform: `/toolkitForm/{study_id}/{parent_id}/signToolkitForm`,
    getLatestSubjectID: `/toolkitForm/latestSubjectID`,
    generateSubjectID: `/toolkitForm/{study_id}/{parent_id}/generateSubjectID`,
    activateCRF: `/toolkitForm/{study_id}/{parent_id}/activate_crf`,
    completeToolkitform: `/toolkitForm/{study_id}/{parent_id}/Completed`,
    getPatientToolkitFormById: `/toolkitForm/{study_id}/{parent_id}/{toolkit_form_id}/getPatientToolkitFormById`,
    enrollSubject: `/toolkitForm/{study_id}/{parent_id}/enrollment`,
    preTrialEvaluation: `/toolkitForm/{study_id}/{site_id}/{patient_id}/screening_date`
  },
  trailNotebookCRF: {
    getVisitsCRFOIDs: `/trialNotebookCRF/{study_id}/getVisitCRFOIDs`,
    getPatientsDetails: `/trialNotebookCRF/{study_id}/{parent_id}/{OID}/getPatientCRFDetails`,
    createCRFData: `/trialNotebookCRF/{study_id}/{site_id}/createCRFData`,
    selectCRFData: `/trialNotebookCRF/{study_id}/{site_id}/selectCRFData`,
    selectCRFDataByID: `/trialNotebookCRF/{study_id}/{site_id}/selectCRFDataByID`,
    updateCRFData: `/trialNotebookCRF/{study_id}/{site_id}/updateCRFData`,
    getVisitLinkedCRFs: `/trialNotebookCRF/{study_id}/{visit_id}/getVisitLinkedCRFs`,
    deleteAssociation: `/trialNotebookCRF/{study_id}/{site_id}/deleteAssociation`,
    deleteAssociationEvent: `/trialNotebookCRF/{study_id}/{site_id}/deleteAssociationEvent`,
    deleteCRFEvent: `/trialNotebookCRF/{study_id}/{site_id}/deleteCRFEvent`,
    getCRFEvent: `/trialNotebookCRF/{study_id}/{site_id}/getCRFEvent`,
    getVisitCRFDetails: `/trialNotebookCRF/{study_id}/{visit_id}/getVisitCRFDetails`,
    getAllVisits: `/toolkitForm/{study_id}/{parent_id}/visit_appointment`,
    startVisit: `/trialNotebookCRF/{study_id}/{site_id}/startVisit`,
    startVisitStatus: `/trialNotebookCRF/{study_id}/{site_id}/startVisitStatus`,
    tsdaCalendarView: `/inTrialPatients/subjectVisits/{study_id}/getAll`
  },
  sivConfirmationLatter: {
    create: `/siteInitiationVisitConfirmationLetter/{site_id}/{study_id}/create`,
    getAll: `/siteInitiationVisitConfirmationLetter/getAll`,
    select: `/siteInitiationVisitConfirmationLetter/{site_id}/{study_id}/select`,
    update: `/siteInitiationVisitConfirmationLetter/{site_id}/{study_id}/update`,
    publish: `/siteInitiationVisitConfirmationLetter/{study_id}/{site_id}/publish`,
    createNewVersion: `/siteInitiationVisitConfirmationLetter/{site_id}/{study_id}/{sq_visit_id}/newSIVConfirmationVersion`
  },
  sivFollowupLetter: {
    getAll: `/siteInitiationVisitFollowUpLetter/getAll`,
    select: `/siteInitiationVisitFollowUpLetter/{site_id}/{study_id}/select`,
    update: `/siteInitiationVisitFollowUpLetter/{site_id}/{study_id}/update`,
    publish: `/siteInitiationVisitFollowUpLetter/{study_id}/{site_id}/publish`,
    createNewVersion: `/siteInitiationVisitFollowUpLetter/{site_id}/{study_id}/{sq_visit_id}/newSIVFollowUpVersion`
  },
  MonitoringVisitLog: {
    getAll: `/monitoringVisitLog/getAll`,
    imvCheckIn: `/monitoringVisitLog/{monitoring_visit_id}/{check_in_date}/monitoringCheckIn`,
    imvCheckOut: `/monitoringVisitLog/{monitoring_visit_id}/{check_out_date}/monitoringCheckOut`,
    sqCheckIn: `/monitoringVisitLog/{monitoring_visit_id}/{check_in_date}/sqCheckIn`,
    updateVisitPurpose: `/monitoringVisitLog/{id}/update`,
    MonitoringVisitAudit: `/audit/applyFilter/getAll`,
    siCheckIn: `/siteInitiationVisitLog/{monitoring_visit_id}/{check_in_date}/sqCheckIn`,
    investigatorSign: `/monitoringVisitLog/InvestigatorSign`,
    representativeSign: `/monitoringVisitLog/SponsorRepresentativeSign`,
    updateActivity: `/monitoringVisitLog/{monitoring_visit_id}/update_activity`,
    mvPublishToIsf: `/monitoringVisitLog/{site_id}/{study_id}/publishToISF`,
    mvPublishToEtmf: `/monitoringVisitLog/{site_id}/{study_id}/publishToEtmf`
  },
  EMREvaluation: {
    getAll: `/emr/{site_id}/{study_id}/{country}/getAll`,
    createSite: `/emr/{site_id}/{study_id}/{country}/site/create`,
    createSponsor: `/emr/{site_id}/{study_id}/{country}/sponsor/create`,
    updateSite: `/emr/{site_id}/{study_id}/{country}/site/update`,
    updateSponsor: `/emr/{site_id}/{study_id}/{country}/sponsor/update`,
    getSite: `/emr/{site_id}/{study_id}/{country}/{event_id}/site/select`,
    getSponsor: `/emr/{site_id}/{study_id}/{country}/{event_id}/sponsor/select`,
    siteSign: `/emr/{site_id}/{study_id}/{country}/site/sign`,
    sponsorSign: `/emr/{site_id}/{study_id}/{country}/sponsor/sign`,
    publishToISF: `/emr/{study_id}/{site_id}/isf/publish`,
    PublishToETMF: `/emr/{study_id}/{site_id}/etmf/publish`,
    createNewEMRversion: `/emr/{site_id}/{study_id}/{country}/newEmrVersion`,
    newEMRVersion: `/emr/{site_id}/{study_id}/{country}/{emr_id}/newEmrVersion`
  },
  NotetoFile: {
    create: '/noteToFile/{site_id}/{study_id}/create',
    select: '/noteToFile/{site_id}/{study_id}/select',
    getAll: '/noteToFile/getAll',
    update: '/noteToFile/{site_id}/{study_id}/update',
    sign: '/noteToFile/{site_id}/{study_id}/sign',
    createNewVersion: '/noteToFile/{site_id}/{study_id}/{note_to_file_id}/newNoteToFileVersion',
    publishToISF: `/noteToFile/{study_id}/{site_id}/isf/publish`,
    PublishToETMF: '/noteToFile/{site_id}/{study_id}/etmf/publish'
  },
  SummaryDashboard: {
    select: `/summary/{site_id}/{study_id}/select`,
    milestone: `/summary/{site_id}/{study_id}/milestone/select`,
    startup: `/summary/{site_id}/{study_id}/startup/select`,
    essentialDocuments: `/summary/{site_id}/{study_id}/essentialDocuments/select`,
    queries: `/summary/{site_id}/{study_id}/queries/select`
  },
  ESign: {
    eSign: `/{site_id}/{study_id}/esign`
  },
  FeasibilityQuestionaries: {
    getAll: `/startup/feasibilityChecks/getAll`,
    create: `/startup/feasibilityChecks/createData`,
    select: `/startup/feasibilityChecks/selectData`,
    update: `/startup/feasibilityChecks/updateData`
  },
  reportConfiguration: {
    select: 'reportconfiguration/select'
  },
  getLatestSubjectId: {
    select: `/patient/{study_id}/counter/select`
  },
  masterList: {
    getStudyDetails: `/masterListStudy/study/{study_id}/select`
  },
  depotsApi: {
    getAll: `/depots/{study_id}/getAll`
  },
  drugSupply: {
    bulkCreate: `/drugsupply/{study_id}/bulk_create`,
    getAll: `/drugsupply/{study_id}/getAll`,
    select: `/drugsupply/{drug_supply_id}/{study_id}/select`,
    update: `/drugsupply/{drug_supply_id}/{study_id}/update`,
    createWithDoc: `drugSupplyLink/{drug_supply_id}/create`,
    deleteSupplyDoc: `drugSupplyLink/{drug_supply_id}/delete`,
    delete: '/drugsupply/drug/{drug_supply_id}/delete',
    templateDownload: `/ctms/drugsupply/template/download`,
    ship: `/drugsupply/ship`,
    shipStatus: `/drugsupply/{drug_supply_id}/ship_status`,
    pendingShipment: `/drugsupply/{study_id}/getAll_get_pending_shipment_record`,
    updateQuantity: `/drugsupply/{drug_supply_id}/{study_id}/updateQuantity`,
    updateStatus: `/drugsupply/approvalWorkflow/{drug_supply_id}/{study_id}/updateStatus`,
    countryAccess: `/drugsupply/{study_id}/{transfer_to}/countryaccess`
  },
  ipResupplyOrder: {
    getAllResupply: `/startup/ipSupply/{site_id}/{study_id}/getAll`,
    selectedResupply: `/startup/ipSupply/{ip_supply_id}/{site_id}/{study_id}/select`,
    updateResupply: `/startup/ipSupply/{site_id}/{study_id}/{ip_resupply_id}/Resupplyupdate`,
    getAllConfirm: `/startup/ipSupply/{site_id}/{study_id}/getAllconfirmedOrder`
  }
};

export const urlKeys: URLKeys = {
  site_id: 'site_id',
  study_id: 'study_id',
  personnel_id: 'personnel_id',
  file_id: 'file_id',
  milestone_id: 'milestone_id',
  query_id: 'query_id',
  code_list_code: 'code_list_code',
  group_name: 'group_name',
  client_name: 'client_name',
  country: 'country',
  application: 'application',
  audit_module_section: 'audit_module_section',
  row_id: 'row_id',
  id: 'id',
  documentName: 'documentName',
  event_id: 'event_id',
  kit_id: 'kit_id',
  level_type: 'level_type',
  file_master_id: 'file_master_id',
  tmf_doc_level: 'tmf_doc_level',
  tmf_level: 'tmf_level',
  application_module_section: 'application_module_section',
  subject_id: 'subject_id',
  application_section: 'application_section',
  issue_id: 'issue_id',
  prescreen_id: 'prescreen_id',
  parent_id: 'parent_id',
  OID: 'OID',
  visit_id: 'visit_id',
  monitoring_visit_id: 'monitoring_visit_id',
  only_update: 'only_update',
  toolkit_form_id: 'toolkit_form_id',
  published_version: 'published_version',
  core_fics_patient_identifier: 'core_fics_patient_identifier',
  check_in_date: 'check_in_date',
  check_out_date: 'check_out_date',
  site: 'site',
  sponsor: 'sponsor',
  emr_id: 'emr_id',
  note_to_file_id: 'note_to_file_id',
  patient_id: 'patient_id',
  sq_visit_id: 'sq_visit_id',
  drug_supply_id: 'drug_supply_id',
  ip_supply_id: 'ip_supply_id',
  ip_name: 'ip_name'
};
